export default __webpack_public_path__ + "ab750ae695ccc0d4e238a42a00844309.png";